import React, { useEffect, useCallback } from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import tPaths from '../../utils/tPaths';
import useStyles from './EmailVerification.styles';
import { useParams } from 'react-router-dom';
import RedbullLogoIcon from '../../assets/images/redbullIcon/RedBullLogoIcon';

const EmailVerification = () => {
  const styles = useStyles();

  const { t } = useTranslation();

  const { status }: any = useParams();

  const isSuccess = status === parseInt(status);
  //codes 0 - success; 1 alreadyVerified; 2 - link has expired

  const getTitle = useCallback((status) => {
    switch (parseInt(status)) {
      case 0:
        return t(tPaths.emailVerification.title);

      case 1:
        return t(tPaths.emailVerification.alreadyVerified);

      case 2:
        return t(tPaths.emailVerification.hasExpired);
      case 3:
        return t(tPaths.emailVerification.error);
      default:
        return t(tPaths.emailVerification.error);
    }
  }, []);

  const changeDocumentTitle = (title: string) => {
    document.title = title;
  };

  useEffect(() => {
    changeDocumentTitle('WNDR email verification');

    return () => changeDocumentTitle('WNDR admin panel');
  }, []);

  return (
    <Box className={styles.background}>
      <Box className={styles.emailVerificationForm}>
        <Box className={styles.inputContainer}>
          <Box alignSelf="center" margin={1} py={1}>
            <RedbullLogoIcon />
          </Box>
          <Typography variant="h5" className={styles.subtitle}>
            {getTitle(status)}
          </Typography>

          {isSuccess && (
            <Typography variant="subtitle2" className={styles.subtitle}>
              {t(tPaths.emailVerification.subTitle)}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default EmailVerification;
